// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3ZLUF","errorLogs":"styles_errorLogs__2hKZ8"};